import React from 'react';
import { createPortal } from 'react-dom';

const SearchPortalProvider: React.FunctionComponent = ({
  children,
}): React.ReactPortal | null => {
  const searchPortalRoot = document.getElementById('search-portal');

  return searchPortalRoot && createPortal(children, searchPortalRoot);
};

export default SearchPortalProvider;
